import { useRef } from 'react'

import { Button, Container, Link, Stack, Text } from '@chakra-ui/react'
import { useMountEffect } from '@react-hookz/web'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const RESET_SCHEME = 'trevize://auth/reset-password'

export const Route = createFileRoute('/desktop/reset-password')({
  validateSearch: z.object({
    token: z
      .string()
      .regex(/^[A-Za-z0-9_-]{1,512}$/)
      .catch(''),
  }),
  component: DesktopResetPasswordPage,
})

function DesktopResetPasswordPage() {
  const { token } = Route.useSearch()
  const resetUrl = `${RESET_SCHEME}?token=${encodeURIComponent(token)}`

  const opened = useRef(false)
  useMountEffect(() => {
    if (token && !opened.current) {
      opened.current = true
      window.location.assign(resetUrl)
    }
  })

  return (
    <Stack minH="100vh" alignItems="center" justify="center" bg="bg.muted">
      <Container maxW="sm">
        <Stack gap="4" alignItems="center" textAlign="center">
          <Text>Opening Trevize to finish resetting your password…</Text>
          {token ? (
            <Button asChild>
              <Link href={resetUrl}>Open Trevize</Link>
            </Button>
          ) : (
            <Text>
              This password reset link is invalid or missing its token.
            </Text>
          )}
        </Stack>
      </Container>
    </Stack>
  )
}
